import Big from "big.js"

const MONTHS_PER_PERIOD = {
  MONTHLY: 1,
  QUARTERLY: 3,
  SEMI_ANNUALLY: 6,
  ANNUALLY: 12,
}

const getDefaultAmount = ({ investedAmount, returnRate }, distributionFrequency, shouldRoundCents = false) => {
  const months = MONTHS_PER_PERIOD[distributionFrequency]

  if (!months) {
    return 0
  }

  const safeInvestedAmount = Number(investedAmount) || 0
  const safeReturnRate = Number(returnRate) || 0

  let distributionAmount = new Big(safeInvestedAmount)
    .times(safeReturnRate)
    .div(100)
    .times(months)
    .div(12)

  if (shouldRoundCents) {
    const cents = distributionAmount.mod(100)
    const roundMode = cents.gt(50) ? Big.roundUp : Big.roundDown

    distributionAmount = distributionAmount
      .div(100)
      .round(0, roundMode)
      .times(100)
  }

  return distributionAmount.round(0).toNumber()
}

export default getDefaultAmount
